/**
 * "A refund is already processing" copy and helpers (DNKADM-0452, DNKAPI-0658).
 *
 * dink-api reports `refundInProgress` (boolean) and `refundInProgressAmount` (major units,
 * or null for a refund recorded before the amount was stored) on a charge row of the
 * transactions feed and on the admin cancellation preview. Both fields may be missing (an
 * older API), which renders exactly as before. The amount is never invented: a null or
 * non-positive amount reads "Refund processing" with no figure.
 */
import { formatMoney } from '@/utils/v2Format';

/** The one guard sentence: beside a disabled refund action, and for a `REFUND_IN_PROGRESS` 409. */
export const REFUND_IN_PROGRESS_MESSAGE = 'A refund for this payment is already processing.';

/** The dink-api error code (HTTP 409) for a refund refused because another was in flight. */
export const REFUND_IN_PROGRESS_CODE = 'REFUND_IN_PROGRESS';

/** The badge text: "Refund of $49.99 processing", or "Refund processing" without a usable amount. */
export function refundProcessingText(
  amount: number | null | undefined,
  currency: string | null | undefined,
): string {
  if (amount === null || amount === undefined || !(amount > 0) || !currency) {
    return 'Refund processing';
  }
  return `Refund of ${formatMoney(amount, currency)} processing`;
}
